import * as usersApi from '../../api/users';
import { fetchTecnicos, fetchAdmins } from '../../api/users';
import { tecnicos, admins, success, user, error } from '../state';
import { askConfirm } from '../confirm';

export async function crearTecnico(payload: Record<string, unknown>) {
  await usersApi.crearTecnico(payload);
  tecnicos.value = await fetchTecnicos();
}

export async function editarTecnico(id: string, data: Record<string, unknown>) {
  await usersApi.editarTecnico(id, data);
  tecnicos.value = await fetchTecnicos();
}

export async function eliminarTecnico(id: string) {
  const ok = await askConfirm(
    'Desactivar técnico',
    'Sus visitas pendientes vuelven al pool para que otro técnico las tome.',
    true
  );
  if (!ok) return;
  try {
    await usersApi.eliminarTecnico(id);
    tecnicos.value = await fetchTecnicos();
    success.value = 'Técnico desactivado.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function toggleDisponibilidad(id: string, disponible: boolean) {
  await usersApi.toggleDisponibilidad(id, disponible);
  tecnicos.value = await fetchTecnicos();
}

// Self-service: el propio técnico se marca disponible/no disponible desde su Perfil.
export async function toggleMiDisponibilidad(disponible: boolean) {
  await usersApi.toggleDisponibilidad(user.value!.id, disponible);
  user.value = { ...user.value!, disponible };
  localStorage.setItem('user', JSON.stringify(user.value));
  success.value = disponible ? 'Te marcaste como disponible.' : 'Te marcaste como no disponible.';
}

export async function loadAdmins() {
  try {
    admins.value = await fetchAdmins();
  } catch {
    admins.value = [];
  }
}

export async function crearAdmin(payload: Record<string, unknown>) {
  await usersApi.crearAdmin(payload);
  admins.value = await fetchAdmins();
}

export async function editarAdmin(id: string, data: Record<string, unknown>) {
  await usersApi.editarAdmin(id, data);
  admins.value = await fetchAdmins();
}

export async function eliminarAdmin(id: string) {
  const ok = await askConfirm(
    'Desactivar administrador',
    'Esta persona va a perder el acceso a la cuenta.',
    true
  );
  if (!ok) return;
  try {
    await usersApi.eliminarAdmin(id);
    admins.value = await fetchAdmins();
    success.value = 'Administrador desactivado.';
  } catch (err) {
    error.value = (err as Error).message;
  }
}

export async function cambiarPw(current: string, nueva: string) {
  await usersApi.cambiarPassword(current, nueva);
}

export async function editarPerfil(data: Record<string, unknown>) {
  const u = await usersApi.editarPerfil(data);
  user.value = { ...user.value!, ...u };
  localStorage.setItem('user', JSON.stringify(user.value));
}
